<template>
	<div class="cut_container" v-show="showBox">
		<div class="content">
			<!-- 顶部遮罩层部分 -->
			<div class="outer-img" ref="overlayTop" :class="overlayTopClass"></div>
			<!-- 底部遮罩层部分 -->
			<div class="outer-img" ref="overlayBottom" :class="overlayBottomClass"></div>
			<!-- 裁剪部分 -->
			<div class="overlay" ref="overlay" :class="overlayClass">
				<div class="overlay-inner">
				</div>
			</div>
			<!-- 手势操作部分 -->
			<div class="resize-container" @touchstart="startMoving" @touchmove="moving" @touchend="endMoving" :style="{top: toTop + 'px', left: toLeft + 'px'}"
			    ref="container">
				<img id="img" :src="dataUrl" crossorigin="anonymous" alt="croper" :style="{width: imgWidth, height: imgHeight}"
				    ref="img">
			</div>
		</div>
		<div class="cut_bottom">
			<div class="btn_cancel" @click="cancel">取消</div>
			<div class="btn_crop js_crop" @click="croper">选取</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		value: {
			type: Boolean,
			default: false
		},
		dataUrl: {
			type: String,
			default: '' // 转base64码后的data字段
		}
	},
	data() {
		return {
			isIOS: navigator.userAgent.match(/iphone/i),
			showBox: false,
			overlayTopClass: 'img-top-default',
			overlayBottomClass: 'img-bottom-default',
			overlayClass: '',
			imgWidth: 'auto',
			imgHeight: 'auto',
			isWidthImg: false,
			toTop: 0,
			toLeft: 0,
			$img: '',
			$container: '',
			$overlay: '',
			$overlayTop: '',
			imageDom: new Image(),
			scale: 0.5, // 压缩系数
			overlayTop: 0, // overlay到顶部距离
			overlayTopheight: 0, // 顶部遮罩层高度
			clientWidth: document.documentElement.clientWidth, // 设备宽度
			clientHeight: document.documentElement.clientHeight, // 设备高度
			event_state: {} // Save the initial event details and container state
		};
	},
	watch: {
		value(val) {
			this.showBox = val;
		},
		showBox(val) {
			this.$emit('input', val);
		},
		dataUrl(val) {
			if (val) {
				this.initCanvas();
			}
		}
	},
	mounted() {
		this.$container = this.$refs.container;
		this.$img = this.$refs.img;
		this.$overlay = this.$refs.overlay;
		this.$overlayTop = this.$refs.overlayTop;
		// 适配
		let ratio = this.clientWidth / this.clientHeight;
		if (ratio > 0.7) {
			this.overlayTopClass = 'img-top-short';
			this.overlayBottomClass = 'img-bottom-short';
			this.overlayClass = 'overlay-short';
		}
		this.initCanvas();
	},
	methods: {
		initCanvas() {
			if (this.dataUrl) {
				// ios传来的是url，需要image设置允许跨域
				if (this.isIOS) {
					this.imageDom.setAttribute('crossOrigin', 'Anonymous');
				}
				this.imageDom.src = this.dataUrl;
				this.imageDom.onload = () => {
					this.overlayTop = this.$overlay.getBoundingClientRect().top;
					this.overlayTopheight = this.$overlayTop.getBoundingClientRect().height;

					let width = this.$img.width,
						height = this.$img.height;

					if (height < width) {
						this.isWidthImg = true;
						this.imgHeight = '100vw';
						this.imgWidth = 'auto';
						this.toTop = this.overlayTopheight;
					} else {
						this.isWidthImg = false;
						this.imgWidth = '100%';
						this.imgHeight = 'auto';
						this.toLeft = 0;
					}
				};
			}
		},
		startMoving(e) {
			e.preventDefault();
			e.stopPropagation();
			this.saveEventState(e);
		},
		moving(e) {
			let touches,
				mouse = {},
				left = 0,
				top = 0;
			e.preventDefault();
			e.stopPropagation();

			touches = e.touches;
			if (this.isWidthImg) {
				let imgWidth = this.$img.getBoundingClientRect().width,
					minLeft = this.clientWidth - imgWidth;

				mouse.x =
					(e.clientX || e.pageX || touches[0].clientX) +
					document.body.scrollLeft;

				left =
					mouse.x -
					(this.event_state.mouse_x -
						this.event_state.container_left);
				// 防止左右超出裁剪框
				if (left > 0) {
					this.toLeft = 0;
				} else if (left < minLeft) {
					this.toLeft = minLeft;
				} else {
					this.toLeft = left;
				}
			} else {
				let minTop =
					this.clientWidth -
					this.$img.getBoundingClientRect().height +
					this.overlayTop;

				mouse.y =
					(e.clientY || e.pageY || touches[0].clientY) +
					document.body.scrollTop;
				top =
					mouse.y -
					(this.event_state.mouse_y - this.event_state.container_top);
				// 防止上下超出裁剪框
				if (top > this.overlayTopheight) {
					this.toTop = this.overlayTopheight;
				} else if (top < minTop) {
					this.toTop = minTop;
				} else {
					this.toTop = top;
				}
			}
		},
		endMoving(e) {
			e.preventDefault();
		},

		saveEventState(e) {
			// Save the initial event details and container state
			this.event_state.container_width = this.$container.getBoundingClientRect().width;
			this.event_state.container_height = this.$container.getBoundingClientRect().height;
			this.event_state.container_left = this.$container.getBoundingClientRect().left;
			this.event_state.container_top = this.$container.getBoundingClientRect().top;
			this.event_state.mouse_x =
				(e.clientX || e.pageX || e.touches[0].clientX) +
				document.body.scrollLeft;
			this.event_state.mouse_y =
				(e.clientY || e.pageY || e.touches[0].clientY) +
				document.body.scrollTop;

			this.event_state.evnt = e;
		},
		cancel() {
			this.showBox = false;
			this.$emit('chooseOther');
		},
		croper() {
			let cropCanvas,
				left = 0,
				top = 0,
				width = this.$overlay.getBoundingClientRect().width,
				height = this.$overlay.getBoundingClientRect().height,
				widthP = this.imageDom.width / this.clientWidth,
				heightP = this.imageDom.height / this.clientWidth;
			if (this.isWidthImg) {
				left = -this.$container.getBoundingClientRect().left;
				left = left * heightP;
				width = width * heightP;
				height = height * heightP;
			} else {
				top =
					this.overlayTop -
					this.$container.getBoundingClientRect().top;
				top = top * widthP;
				width = width * widthP;
				height = height * widthP;
			}

			cropCanvas = document.createElement('canvas');
			cropCanvas.width = width;
			cropCanvas.height = height;
			cropCanvas
				.getContext('2d')
				.drawImage(
					this.imageDom,
					left,
					top,
					width,
					height,
					0,
					0,
					width,
					height
				);
			this.$emit(
				'afterCrop',
				cropCanvas.toDataURL('image/jpeg', 0.5)
			);
		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../../assets/style/public.scss';
.cut_container {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background: #000;
	z-index: 9999;
}

.content {
	min-height: px2rem(908px);
	max-height: px2rem(2560px);
	overflow: hidden;
}

.overlay {
	position: absolute;
	z-index: 999;
	width: 100%;
	height: 100vw;
	border-top: solid px2rem(4px) #ccc;
	border-bottom: solid px2rem(4px) #ccc;
	box-sizing: border-box;
	pointer-events: none;
	top: px2rem(150px);
}

.overlay-short {
	top: px2rem(75px);
}

.img-top-default {
	height: px2rem(150px);
	top: 0;
}

.img-top-short {
	height: px2rem(75px);
	top: 0;
}

.outer-img {
	filter: alpha(opacity=50);
	-moz-opacity: 0.5;
	opacity: 0.5;
	background: #000;
	position: absolute;
	z-index: 1000;
	width: 100%;
}

.resize-container {
	position: relative;
	cursor: move;
	margin: 0 auto;
	zoom: 1;
}

.img-bottom-default {
	top: px2rem(900px);
	height: 50%;
}

.img-bottom-short {
	top: px2rem(825px);
	height: 50%;
}

.cut_bottom {
	width: 100%;
	height: px2rem(144px);
	line-height: px2rem(144px);
	position: fixed;
	bottom: 0;
	font-size: px2rem(38px);
	color: #fff;
	background: #141414;
	z-index: 9999;
}

.btn_cancel {
	float: left;
	padding: 0 px2rem(28px);
}

.btn_crop {
	float: right;
	padding: 0 px2rem(28px);
}
</style>



// WEBPACK FOOTER //
// cutImg.vue?1de9407e